<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square" stroke-linejoin="miter" aria-hidden="true">
    <path d="M4 20 L8 20 L8 14 L14 14 L14 8 L20 8 L20 4"/>
  </svg>
</template>
